import image1 from '../../../../assets/images/work/hoisting-rigging/H&R_detailed_img_1.jpg';
import image2 from '../../../../assets/images/work/hoisting-rigging/H&R_detailed_img_2.jpg';
import image4 from '../../../../assets/images/work/hoisting-rigging/H&R_detailed_abovefooter.jpg';

import artwork from '../../../../assets/images/art_2.png';

const Data_HoistingRigging = {
  content: (
    <>
      {/* PROBLEM + CHALLENGES */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                {/* PROBLEM */}
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">PROBLEM</h4>

                  <div className="paragraph light-1">
                    <p>
                      Hoisting and rigging is a high-risk skill set that typically requires access to large-scale equipment
                      and supervised hands-on practice. For many training centres, that equipment is limited or unavailable,
                      leaving learners with classroom knowledge but fewer opportunities to build confidence through realistic
                      repetition.
                      <br />
                      <br />
                      NETCO approached NORCAT to address a key gap: many electrical workers were reluctant to take on roles
                      requiring hoisting and rigging because they felt under-prepared after traditional classroom training
                      alone. Hoisting and Rigging VR was developed to bridge theory and practice by providing safe access to
                      realistic virtual equipment and scenarios.
                    </p>
                  </div>
                </div>

                {/* CHALLENGES */}
                <div className="col-lg-6 second-column">
                  <h4 className="heading heading-small light-2">CHALLENGES</h4>

                  <div className="paragraph light-1">
                    <p>
                      The challenge was to deliver a training experience that feels realistic enough to reinforce critical
                      decision-making—while keeping it safe, repeatable, and easy to deploy. Hoisting and rigging requires
                      accurate physics, correct equipment selection, and clear communication between workers, including
                      proper hand signals for crane operation.
                      <br />
                      <br />
                      The VR environment also needed to reflect real job-site variables—like environmental conditions—and
                      support the kind of teamwork learners encounter on the ground, without introducing the risks
                      associated with live suspended loads.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PROJECT CONTENT */}
      <div className="project-content">
        <div className="project-content-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-large dark-1">
                    Next-level hoisting and rigging skills—built through immersive VR training.
                  </h2>

                  <div className="paragraph dark-1">
                    <p>
                      In partnership with the National Electrical Trade Council of Canada (NETCO), NORCAT launched Hoisting
                      and Rigging VR—an experiential VR training solution designed to enhance hands-on hoisting and rigging
                      education. Available on Meta’s Oculus platform, the program complements NETCO’s 3-day instructor-led
                      course by giving learners a safe virtual space to practice crane operation, rigging, and load handling.
                      <br />
                      <br />
                      By translating classroom concepts into interactive practice, trainees can build confidence and
                      competence before stepping into real-world situations where the consequences are higher.
                    </p>
                  </div>

                  <div className="heading heading-medium dark-1">
                    <p>Identifying the Need</p>
                  </div>

                  <div className="paragraph dark-1">
                    <p>
                      Many training centres do not have the resources required to provide realistic hoisting and rigging
                      practice with large-scale equipment. Hoisting and Rigging VR was created to fill that gap, enabling
                      learners to interact with virtual equipment and demonstrate classroom theory in a practical, hands-on
                      way—without relying on physical cranes or heavy machinery.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image-wrapper">
            <div className="single-image">
              <img src={image1} alt="Hoisting and Rigging VR environment" />
            </div>
            <div className="single-image">
              <img src={image2} alt="Hoisting and Rigging VR interaction and tools" />
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <div className="project-content-inner">
                  <h2 className="heading heading-medium dark-1">Innovation & Engagement</h2>

                  <div className="paragraph dark-1">
                    <p>
                      Hoisting and Rigging VR combines classroom theory with a highly interactive, physics-based virtual
                      environment. Learners can select appropriate equipment, rig different loads, practice crane hand
                      signals, and manage variables like wind and rain. The experience reinforces safe habits through
                      repetition—using taglines, guiding loads, and coordinating with a simulated crew.
                    </p>
                  </div>

                  <div className="text-list medium dark-1">
                    <ul>
                      <li>• Physics-based load handling and rigging practice in VR</li>
                      <li>• 3D controller tracking to learn hoisting hand signals and gestures</li>
                      <li>• A range of ropes, chains, and shackles based on scenario needs</li>
                      <li>• Simulated environmental factors like wind and rain</li>
                      <li>• NPC workers that can assist with taglines and positioning</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="single-image">
            <img src={image4} alt="Hoisting and Rigging VR training scenario" />
          </div>
        </div>
      </div>

      {/* RESULTS */}
      <div className="text-content">
        <div className="text-content-wrapper position-relative bg-black">
          <div className="text-content-inner">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h4 className="heading heading-small light-2">RESULTS</h4>

                  <div className="paragraph light-1">
                    <p>
                      Since rollout, Hoisting and Rigging VR has enriched training centres across Canada by enabling a more
                      comprehensive, practical, and cost-effective program. Learners are able to practice critical skills in
                      a safe and realistic environment, building greater confidence and readiness for real job-site
                      applications.
                      <br />
                      <br />
                      NETCO has seen increased enrolment, with feedback highlighting how the virtual experience strengthens
                      understanding and retention of rigging concepts. As more centres adopt the program, it continues to
                      expand access to hands-on training that would otherwise be difficult or impossible to deliver at scale.
                    </p>
                  </div>
                </div>

                <div className="col-lg-5 offset-lg-1 second-column">
                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">PLATFORM</h4>
                    <div className="paragraph light-1">
                      <p>PC VR</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">CLIENT</h4>
                    <div className="paragraph light-1">
                      <p>NETCO / IBEW</p>
                    </div>
                  </div>

                  <div className="content-wrapper">
                    <h4 className="heading heading-small light-2">WEBSITE</h4>
                    <div className="paragraph light-1">
                      <p>
                        <a href="https://netco.org" target="_blank" rel="noopener noreferrer">
                          netco.org
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-content-footer">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-md-6">
                  <h3 className="heading heading-large light-1">
                    Have an idea?
                    <br />
                    Let’s explore it together.
                  </h3>
                </div>
                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                  <div className="button-wrapper">
                    <a className="button button-1" href="/Contact">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="artwork artwork-2">
            <img src={artwork} alt="artwork" />
          </div>
        </div>
      </div>
    </>
  ),
};

export default Data_HoistingRigging;


